module.exports = __webpack_public_path__ + "static/media/39-2.228d24cb.mp3";